export default "__VITE_ASSET__39158df8__"